import s from './RequestCard.module.css';
import { Flex } from '@repo/ui/Flex';
import { Text } from '../Language/Language';
import { Link } from '@tanstack/react-router';
import type { SubmittedRequest } from '../../graphql/query/getOrder';
import { getParams } from '../../utils/searchParams';
import { formatToShort } from '../../utils/dates';

export const RequestCard = ({
  id,
  submitDate,
  items,
  deliveryMethod,
  retailer,
}: SubmittedRequest & { retailer: string | null }) => {
  return (
    <Flex key={id} direction="column" gap="g-32" className={s.card}>
      <Flex direction="column" gap="g-16">
        <Flex direction="row">
          {items.map((item) => (
            <img
              alt={item.name ?? ''}
              className={s.image}
              key={item.id}
              src={item.image?.url ?? ''}
            />
          ))}
        </Flex>

        <Flex
          className={s.details}
          justifyContent="space-between"
          alignItems="center"
          padding="p-24"
        >
          <Flex direction="column">
            <strong>
              <Text
                langKey={`Global.itemSelection.SubmittedRequests.Details.delivery.${deliveryMethod}`}
              />
            </strong>
            {submitDate && (
              <Text
                langKey={`Global.itemSelection.SubmittedRequests.Details.SubmitDate.${items.length === 1 ? 'one' : 'many'}`}
                replacementTokens={{
                  date: formatToShort(submitDate, getParams()?.locale),
                  itemCount: `${items.length}`,
                }}
              />
            )}
          </Flex>
          <Link
            to="/$retailer/submitted-details/$requestId"
            params={{ requestId: id, retailer: retailer ?? 's' }}
            search={(prev) => {
              return { ...prev };
            }}
          >
            <Text
              langKey={'Global.itemSelection.SubmittedRequests.Details.Link'}
            />
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};
